import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { globalSettingsOptimizeFieldConfigurationSchemeRoute } from '@atlassian/jira-router-routes-admin-pages-fields-routes/src/globalSettingsOptimizeFieldConfigurationSchemeRoute.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@atlassian/jira-router-resources-post-office/src/services/index.tsx';
import {
	OptimizeFieldConfigurationSchemePage,
	LazyOptimizeFieldConfigurationSchemePagePage,
} from './ui/spa/admin-pages/fields/optimize-field-configuration-scheme-page/index.tsx';

export const globalSettingsOptimizeFieldConfigurationSchemeRouteEntry = createEntry(
	globalSettingsOptimizeFieldConfigurationSchemeRoute,
	() => ({
		group: 'global-settings',

		component: componentWithFG(
			'field_streamlining_ui',
			OptimizeFieldConfigurationSchemePage,
			ErrorPagesNotFound,
		),

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		canTransitionIn: () => fg('field_streamlining_ui'),

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyOptimizeFieldConfigurationSchemePagePage],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-fields-entries/src/globalSettingsOptimizeFieldConfigurationSchemeRouteEntry.tsx',
				whichExportToUse: 'globalSettingsOptimizeFieldConfigurationSchemeRouteEntry',
			},

			enabled: true,
		},
	}),
);
